(function () {
  'use strict';

  let angular = window.angular;

  PublicRouter.$inject = ['$stateProvider'];

  angular.module('app').config(PublicRouter);

  function PublicRouter($stateProvider) {
    $stateProvider
      .state('public', {
        url: '?:style',
        abstract: true,
        params: {
          style: { type: 'string', inherit: true },
        },
        template:'<ui-view></ui-view><spinner show="$root.viewLoading" css-class="\'black\'"></spinner>',
      })
      .state('public.login', {
        url: '/login',
        component: 'publicLogin',
        login: true,
      })
      .state('public.resetPassword', {
        url: '/reset-password?error',
        component: 'publicResetPassword',
        login: true,
      })
      .state('public.changePassword', {
        url: '/change-password?uid&token',
        component: 'publicChangePassword',
        login: true,
      })
      .state('public.confirmAccount', {
        url: '/confirm?uid&token',
        component: 'publicAccountConfirmation',
        login: true,
      })
      .state('public.validateEmail', {
        url: '/validate-email',
        component: 'publicVerifyEmail',
        login: true,
      })
      .state('public.activeDirectory', {
        url: '/aad?token&user',
        component: 'activeDirectoryCallback',
        login: true,
      });
  }
})();
